import * as _ from 'lodash';
export default function mergeComponentAndThemeStyles(componentStyle, themeComponentStyle, themeStyle) {
  var componentThemedStyle = _.merge({}, componentStyle, themeComponentStyle);

  var intersectedRootThemeStyle = _.pick(themeStyle, _.keys(componentThemedStyle));

  return _.merge({}, intersectedRootThemeStyle, componentThemedStyle);
}